<template>
<div class="chapter">
<div class="inner_page">
<div id="V4305ebook-7.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="CT para-style-override-8" id="toc_marker-8"><span class="char-style-override-2">‘A graceful generation that had to work for men wrapped up in their individual egos, a sin their ﬂesh is not heir to.’</span></p>
<p class="P-Epi-02 para-style-override-9"><span class="char-style-override-10">Joe Flaherty, </span><span class="char-style-override-3">Managing Mailer</span></p>
<p class="P-Epi-02 para-style-override-10"><span>‘. . . </span><span class="char-style-override-10">the best of a generation were being lost—some among the hippies to drugs, some among the radicals to an almost hysterical frenzy of ­alienation.’</span></p>
<p class="P-Epi-02 para-style-override-9"><span class="char-style-override-10">I.F. Stone</span></p>
<p class="P-Epi-02 para-style-override-11"><span class="char-style-override-10">§</span></p>
<p class="P-Epi-02 para-style-override-12"><span class="char-style-override-10">‘It was fun to have that sense of engagement when you jumped on the earth and the earth jumped back.’</span></p>
<p class="P-Epi-02 para-style-override-9"><span class="char-style-override-10">Abbie Hoffmann</span></p>
<p class="P-Epi-02 para-style-override-10"><span class="char-style-override-10">‘It takes a long time for sentiments to collect into action, and often they never do</span><span> . . . </span><span class="char-style-override-10">I wanted to make actions rather than effect sentiments.’</span></p>
<p class="P-Epi-02 para-style-override-9"><span class="char-style-override-10">Norman Mailer, </span><span class="char-style-override-3">Paris Review Interview</span></p>
<p class="P-Epi-02 para-style-override-11"><span class="char-style-override-10">§</span></p>
<p class="P-Epi-02 para-style-override-12"><span class="char-style-override-10">‘Worst of all, expansion is eroding the precious and time honored values of community with neighbors and communion with ­nature. The loss of these values breeds loneliness and boredom and ­indifference</span><span> . . . </span><span class="char-style-override-10">once the battle is lost, once our natural splendor is destroyed, it can never be recaptured. And once man can no longer walk with beauty or wonder at nature his spirit will wither and his sustenance be wasted.’</span></p>
<p class="P-Epi-02 para-style-override-9"><span class="char-style-override-10">Lyndon Baines Johnson</span></p>
<p class="P-Epi-02 para-style-override-13"><span class="char-style-override-10">‘You can’t dig the moon</span></p>
<p class="P-Epi-02"><span class="char-style-override-10">Until</span></p>
<p class="P-Epi-02"><span class="char-style-override-10">You dig the earth.’</span></p>
<p class="P-Epi-02 para-style-override-9"><span class="char-style-override-10">William Eastlake, from </span><span class="char-style-override-3">Whitey’s on the Moon Now</span></p>
<p class="P-Epi-02 para-style-override-11"><span class="char-style-override-10">§</span></p>
<p class="P-Epi-02"><span class="char-style-override-10">‘No one was saved.’</span></p>
<p class="P-Epi-02"><span class="char-style-override-10">Paul McCartney</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// V4305ebook7.vue?b61ee5ca